export enum NotificationChannelType {
  Email = 0,
  SMS = 1,
  Push = 2
}
  